/**
 * The page's viewport policy, written into `<meta name="viewport">` once the flags are known: the content follows the
 * notch (viewport-fit=cover), the on-screen keyboard resizes it (interactive-widget, Chrome on Android; iOS shrinks the
 * visual viewport, useViewport.ts), and pinch-zoom is locked only where the flags say so — the totem.
 */
export function viewportContent(zoom: boolean): string {
  const parts = ['width=device-width', 'initial-scale=1', 'viewport-fit=cover', 'interactive-widget=resizes-content'];
  return (zoom ? parts : [...parts, 'maximum-scale=1', 'user-scalable=no']).join(', ');
}

export function applyViewportPolicy(zoom: boolean, doc: Document = document): void {
  let meta = doc.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!meta) {
    meta = doc.createElement('meta');
    meta.name = 'viewport';
    doc.head.appendChild(meta);
  }
  meta.content = viewportContent(zoom);
}
